import { Observable, map } from "rxjs";
import { WebServicesService } from "../webservices.service";
import { ApiService } from "./_api.service";
import { StockMovement } from "src/app/_models/stockmovement";
import { Enums } from "src/app/_models/_enums";
import { environment } from 'src/environments/environment';

export class StockMovementApiService{
    constructor(private _ws: WebServicesService){}
   
    // StockMovement
    get(): Observable<StockMovement[]> {
        const url = `${environment.wsBaseUrl}/api/StockMovement/All`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_STOCKMOVEMENTS).pipe(
            map((sma: Array<any>) => {
                sma.map(sm => {
                    const type = Enums.CausalType.filter(x => x.id === sm.causal)[0];
                    if (type) {
                        sm._causalName = type.value;
                    }
                    sm.date = new Date(sm.date);
                    sm.createdDateTime = new Date(sm.createdDateTime);
                    sm.modifiedDateTime = new Date(sm.modifiedDateTime);
                    return sm;
                });
                return sma;
            }));
    }

    getList(ids: number[]): Observable<string> {
        const url = `${environment.wsBaseUrl}/api/StockMovement/list?${ids.map(id => `Id=${encodeURIComponent(id)}`).join('&')}`;
        return this._ws.getCsvContent(url);
    }

    getOne(id: number): Observable<StockMovement> {
        const url = `${environment.wsBaseUrl}/api/StockMovement/${encodeURIComponent(id)}`;
        return this._ws.getWithoutCache(url).pipe(
            map(sm => {
                sm.date = new Date(sm.date);
                sm.createdDateTime = new Date(sm.createdDateTime);
                sm.modifiedDateTime = new Date(sm.modifiedDateTime);
                return sm;
            }));
    }

    put(stockMovement: StockMovement) {
        const url = `${environment.wsBaseUrl}/api/StockMovement/${encodeURIComponent(stockMovement.id)}`;
        return this._ws.putJson(url, stockMovement);
    }

    post(stockMovement: StockMovement): Observable<StockMovement> {
        const url = `${environment.wsBaseUrl}/api/StockMovement/`;
        return this._ws.postJson(url, stockMovement);
    }

    delete(stockMovement: StockMovement) {
        const url = `${environment.wsBaseUrl}/api/StockMovement/${encodeURIComponent(stockMovement.id)}`;
        return this._ws.deleteHttp(url);
    }

}
